import React, { FC, memo, useState } from "react"
import { Input } from "../../../Input"
import { WrapButton, WrapEmail } from "../WeWillBeBackSoon/styles"
import { Button } from "../../../Button"
import background from "./images/background.webp"
import {
  RootStyled,
  TitleStyled,
  TitleRedStyled,
  MaxWidthEmail,
} from "./styles"

export const WantToBeInformed: FC = memo(() => {
  const [email, setEmail] = useState("")

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const validateEmail = (value: string) => {
    return String(value)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  // Submission is deliberately absent: the endpoint this used to POST to
  // (`/v1/save-email`) lived on the retired origin, and Pages serves static
  // files only. Typing, validation and the disabled state work; attach a
  // handler to Button's `onClick` once a receiver exists.
  return (
    <RootStyled style={{ backgroundImage: `url(${background})` }} id="info">
      <TitleStyled>
        WANT TO&nbsp;
        <TitleRedStyled>BE INFORMED</TitleRedStyled>?
      </TitleStyled>
      <MaxWidthEmail>
        <WrapEmail>
          <Input
            label="Enter your email:"
            inputProps={{
              type: "email",
              name: "EMAIL",
              required: true,
              placeholder: "your@email.com",
              onChange,
              value: email,
            }}
          />
          <WrapButton>
            <Button label="SUBSCRIBE" disabled={!validateEmail(email)} />
          </WrapButton>
        </WrapEmail>
      </MaxWidthEmail>
    </RootStyled>
  )
})
